import { LockFilled } from "@ant-design/icons";
import { Spin } from "antd";
import ErrorView from "~components/Error";
import { useUserPermissions } from "~context/UserPermissionsContext";

const AccessDeniedPage = () => {
  const { hasOrganizationAccess, isLoadingPermissions } = useUserPermissions();

  if (isLoadingPermissions) {
    return <Spin size={"large"} />;
  }

  return (
    <ErrorView
      titleIntlKey={hasOrganizationAccess ? "access.page.restricted.title" : "access.organization.restricted.title"}
      descriptionIntlKey={hasOrganizationAccess ? "access.page.restricted.description" : "access.organization.restricted.description"}
      actionButtonIntlKey="go.back"
      Icon={LockFilled}
    />
  );
};

export default AccessDeniedPage;
